// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const safeJsonParse = <T = Record<string, any>>(string: string): T | null => {
	try {
		return JSON.parse(string);
	} catch {
		return null;
	}
};

export function safeStringify(obj: unknown): string {
	try {
		return JSON.stringify(obj);
	} catch {
		return '{}';
	}
}

/** One string field off a recorded JSON payload, when it holds one. */
export const readJsonString = (data: unknown, field: string): string | undefined => {
	if (!data || typeof data !== 'object') {
		return undefined;
	}

	const value: unknown = Object.entries(data).find(([key]) => key === field)?.[1];

	return typeof value === 'string' ? value : undefined;
};
